import { lazy } from "react";

export { COUNTERPARTIES_PATH } from "./counterparties-path";
export const Counterparties = lazy(() => import("./counterparties"));
